import {BaseService} from "./base.service";

class TicketQuoterService extends BaseService {
    constructor() {
        super('api/ticket-quoter');
    }
}

export const ticketQuoterService = new TicketQuoterService();
